import { loadDeliveryInfo } from "./checkoutStorage";

const KEY = "fl_context_shop";

export const setContextShop = (shop) => {
  if (!shop?.id) return;
  const ctx = { id: shop.id, name: shop.name, subdomain: shop.subdomain, city: shop.comune || shop.city, is_fallback_store: !!shop.is_fallback_store };
  sessionStorage.setItem(KEY, JSON.stringify(ctx));
  window.dispatchEvent(new CustomEvent("fl-shop-viewed", { detail: { shop_id: ctx.id, city: ctx.city } }));
};

export const getContextShop = () => {
  try {
    const c = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (c?.id) return c;
  } catch { /* ignore */ }
  const d = loadDeliveryInfo();
  return d?.shop_id ? { id: d.shop_id, name: d.shop_name, city: d.city, is_fallback_store: !!d.is_fallback } : null;
};

export const clearContextShop = () => sessionStorage.removeItem(KEY);
